import Home from './Pages/Home/Home';
import MoreMenuSubTab from './Pages/Mobile/MoreMenuSubTab/MoreMenuSubTab';
import NatNal from './Pages/NatNal/NatNal';
import MyLoadsContainer from './Pages/MyLoads/MyLoadsContainer';
import Loads from './Pages/MyLoads/Loads';
import Preferences from './Pages/Preferences/Preferences';
import Feedback from './Pages/Feedback/Feedback';
import Support from './Pages/Support/Support';
import Profile from './Pages/Profile/Profile';
import Manage from './Pages/Mobile/Manage/Manage';
import MoreTab from './Pages/Mobile/MoreTab/MoreTab';
import SearchContainer from './Pages/Search/SearchContainer';
import SearchResults from './Pages/Mobile/SearchResults/SearchResults';
import ExpandedResults from './Pages/Mobile/ExpandedResults/ExpandedResults';
import Results from './Pages/Results/Results';
import NotFound from './Pages/NotFound/NotFound';
import FinancialInfo from './Pages/FinancialInfo/FinancialInfo';

interface RouteConfig {
  path: string;
  element: JSX.Element;
  restrictionSlug?: string;
}

const routeConfig: RouteConfig[] = [
  { path: '/', element: <Home /> },
  { path: '/feedback', element: <Feedback /> },
  { path: '/support', element: <Support /> },
  { path: '/profile', element: <Profile /> },
  { path: '/natnal', element: <NatNal /> },
  { path: '/search', element: <SearchContainer /> },
  { path: '/search/recents', element: <Results /> },
  { path: '/search/favorites', element: <Results /> },
  { path: '/search/results', element: <SearchResults /> },
  { path: '/myloads', element: <MyLoadsContainer /> },
  { path: '/myloads/loads', element: <Loads /> },
  { path: '/financial-info', element: <FinancialInfo /> },
  { path: '/expanded/:type/:id', element: <ExpandedResults /> },
  { path: '/manage', element: <Manage /> },
  { path: '/more-mobile/:MoreSubMenu/:uid', element: <MoreMenuSubTab /> },
  { path: '/more-mobile', element: <MoreTab /> },
  { path: '/preferences', element: <Preferences /> },
  { path: '*', element: <NotFound /> },
];

export default routeConfig;
